import React, { useState, useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import ResponsiveAdminSidebar from './ResponsiveAdminSidebar';
import ResponsiveAdminHeader from './ResponsiveAdminHeader';
import MobileMenuDrawer from './MobileMenuDrawer';
import { useAuth } from '../contexts/AuthContext';

/**
 * ResponsiveAdminLayout - Premium Design
 * Exactly matches the Owner's ResponsiveAppShell.js structure
 */
const ResponsiveAdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-[#F0F2F5] overflow-hidden">
      {/* DESKTOP ONLY: Responsive Sidebar - Fixed, Full Height with padding for rounded effect */}
      <div className="hidden lg:flex lg:flex-shrink-0 p-1">
        <ResponsiveAdminSidebar 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
          isMobile={false} 
        />
      </div>

      {/* MOBILE ONLY: Off-Canvas Drawer - Fixed position, slides in from left */}
      <MobileMenuDrawer isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)}>
        <ResponsiveAdminSidebar 
          isOpen={mobileMenuOpen} 
          onClose={() => setMobileMenuOpen(false)} 
          isMobile={true} 
        />
      </MobileMenuDrawer>

      {/* Main Content Area - With horizontal gap from sidebar */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden p-1 pl-0 lg:pl-1">
        {/* DESKTOP ONLY: Top Header with rounded top corners */}
        <div className="hidden lg:block flex-shrink-0 bg-white rounded-t-lg shadow-sm overflow-hidden">
          <ResponsiveAdminHeader 
            onMenuClick={() => setSidebarOpen(true)} 
            user={user}
          />
        </div>

        {/* MOBILE ONLY: Mobile Top Nav - Fixed at top */}
        <div className="lg:hidden flex-shrink-0">
          <ResponsiveAdminHeader 
            onMenuClick={() => {
              setMobileMenuOpen(prev => !prev);
            }} 
            user={user}
            isMobile={true}
          />
        </div>

        {/* Content Area - With rounded bottom corners on desktop */}
        <main className="flex-1 overflow-auto pt-16 lg:pt-0 lg:rounded-b-lg lg:shadow-sm bg-[#F0F2F5]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ResponsiveAdminLayout;
